import { gql } from '@apollo/client';
import { DeliveryOption } from '@global/types/types';

export interface GET_DELIVERY_OPTIONS_RESPONSE {
  wGetCheckoutDeliveryOptions: {
    status: string;
    errors: [];
    country: string;
    deliveryOptions: DeliveryOption[];
  };
}

export interface GET_DELIVERY_OPTIONS_VARIABLES {
  uid: string;
  country?: string;
}

export const GET_DELIVERY_OPTIONS = gql`
  query getDeliveryOptions($uid: UUID!, $country: String) {
    wGetCheckoutDeliveryOptions(uid: $uid, country: $country)
  }
`;
